<script>
	import { Router, Route } from "svelte-routing";
	import Home from "./pages/Home.svelte";
	import Impressum from "./pages/Impressum.svelte";
	import Privacy from "./pages/Privacy.svelte";
	import Confirmed from "./pages/Confirmed.svelte";
	import Manage from "./pages/Manage.svelte";
</script>

<Router basepath="/">
	<Route path="impressum/" component="{Impressum}" />
	<Route path="datenschutz/" component="{Privacy}" />
	<Route path="weitersagen/" component="{Confirmed}" />
	<Route path="verwaltung/" component="{Manage}" />
	<Route path="/" component="{Home}" />
</Router>
